// @ts-nocheck




import React from 'react';

import { fuelMultiplierApi } from '../../lib/api';




import AutocompleteSelect from './AutocompleteSelect';





export default (selectProps) =>
<AutocompleteSelect
  fetch={async (params) =>
  await fuelMultiplierApi.fetchFuelMultipliers({
    ...selectProps.filter,
    ...params
  })
  }
  fetchSingle={fuelMultiplierApi.fetchFuelMultiplier}
  notFoundText="Коэффициенты не найдены"
  valueKey="id"
  renderOption={(multiplier, Option) =>
  <Option key={multiplier.id} value={multiplier.id} multiplier={multiplier}>
        {multiplier.name} x{multiplier.value}
      </Option>
  }
  {...selectProps} />;
